import React from "react";



const TenantPortal = () => {

return(


    <>
    </>
)




}

export {TenantPortal}